// import ReservePrint from './ReservePrint';

export default {
  // component: ReservePrint,
  component: load(() => import(/* webpackChunkName: "Feed-ReservePrint" */ './ReservePrint')),
  priority: 10,
  permissions: ['FeedingConsoleMenu/PaymentCheckPrint/UserPaymentCheckPrintMenu'],
  name: app.translate('routes.home.feed.ReservePrint Users'),
  icon: 'account-multiple',
  drawer: true,
};


